import { render } from "./userLostPass.vue?vue&type=template&id=0e957999&scoped=true"
import script from "./userLostPass.vue?vue&type=script&lang=js"
export * from "./userLostPass.vue?vue&type=script&lang=js"

import "./userLostPass.vue?vue&type=style&index=0&id=0e957999&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e957999"]])

export default __exports__